import { Alert, AlertDescription } from '@/components/ui/alert';
import { Construction } from 'lucide-react';
import { useStagingMode } from '@/hooks/useAppSettings';

export const StagingBanner = () => {
  const { isEnabled } = useStagingMode();

  if (!isEnabled) return null;

  return (
    <Alert className="rounded-none border-x-0 border-t-0 bg-warning/10 border-warning">
      <Construction className="h-4 w-4" />
      <AlertDescription className="font-medium">
        🚧 Staging Environment - Testing Mode Active
      </AlertDescription>
    </Alert>
  );
};